export const PAGE_LOADER = "PAGE_LOADER";

export const NAVBAR_ORIENTATION = "NAVBAR_ORIENTATION";